import React from 'react'

const CreateViewPage = () => {

  return (
    <>
      <section className='d-flex gap-3 flex-wrap'>
        {/* Left Block */}
        <div className='bg-light rounded-3 p-3 border border-primary flex-grow-1'>
          <button type="button" className='btn btn-primary mb-3 w-100'>Create a New Page</button>

          {/* Search */}
          <div className='d-flex align-items-center gap-1 border ps-2 bg-white rounded-3 mb-3'>
            <img src="/images/icons/search-black.svg" style={{ height: '20px' }} alt="search" />

            <input type="search" className='form-control border-0 shadow-none rounded-3' placeholder='Search here...' />
          </div>

          {/* Pages */}
          <div>
            {
              Array(3).fill(0).map((value, index) => (
                <div className={`${index === 0 && 'bg-primary-subtle'} border d-flex align-items-center gap-3 mb-3 px-3 py-2 rounded-3`} key={index}>
                  <img src="/images/profile.png" className='border rounded-circle' style={{ height: '40px' }} alt="profile" />

                  <div>
                    <h5 className='mb-0'>Business Page {index + 1}</h5>
                    <small className='text-primary'>@businesspage{index + 1}</small>
                  </div>
                </div>
              ))
            }
          </div>
        </div>

        {/* Right Block */}
        <div className='bg-light rounded-3 p-3 border border-primary flex-grow-1'>
          <div className='d-flex gap-3'>
            <img src="/images/profile.png" className='rounded-circle border' style={{ height: '50px' }} alt="profile" />

            <div className='d-flex flex-column'>
              <h6 className='mb-0'>Business Page 1</h6>
              <small className='text-secondary'>ID: 123456789</small>
              <small className='text-primary'>@businesspage1</small>
            </div>
          </div>
        </div>
      </section> 
    </>
  )
}

export default CreateViewPage;